var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 13.5,
    height: 13.5,
    rx: 3.75,
    fill: "#EFFCFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 13.5,
    height: 13.5,
    rx: 3.75,
    stroke: "#34656D",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4100_7833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 2.8335V4.50016M3.25 6.16683H10.75M5.33333 2.8335V4.50016M9.08333 7.8335H6.58333M7.41667 9.50016H4.91667M4.91667 7.8335H4.92083M9.08333 9.50016H9.0875M4.08333 3.66683H9.91667C10.3769 3.66683 10.75 4.03993 10.75 4.50016V10.3335C10.75 10.7937 10.3769 11.1668 9.91667 11.1668H4.08333C3.6231 11.1668 3.25 10.7937 3.25 10.3335V4.50016C3.25 4.03993 3.6231 3.66683 4.08333 3.66683Z",
    stroke: "#34656D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4100_7833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetDate);
export default __webpack_public_path__ + "static/media/target_date.05ef849fdc13e3ee22a171a4893c8d12.svg";
export { ForwardRef as ReactComponent };